import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../services/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            // Session expirée ou révoquée : déconnexion puis écran de connexion.
            // Uniquement si un utilisateur était connecté — sinon on rechargerait la page
            // de connexion en boucle.
            // Critère : la page courante (pas sessionStorage, vidé par Firebase quand la
            // session se perd dans un autre onglet — l'utilisateur restait alors bloqué).
            if (err.status === 401 && !location.pathname.startsWith('/account')) {
                const retour = encodeURIComponent(location.pathname + location.search);
                Promise.resolve()
                    .then(() => this.authenticationService.logout())
                    .catch(() => null)
                    .finally(() => location.assign(`/account/login?returnUrl=${retour}`));
            }

            // Abonnement expiré (ferme en lecture seule) : le bandeau d'abonnement s'affiche partout
            if (err.status === 402) {
                window.dispatchEvent(new CustomEvent('abonnement-expire'));
            }

            // HttpErrorResponse intacte : les écrans lisent err.error.message (409, 403…) et err.status
            return throwError(err);
        }));
    }
}
